import { render, staticRenderFns } from "./TaxationModality.vue?vue&type=template&id=4de2dde1&scoped=true&"
import script from "./TaxationModality.vue?vue&type=script&lang=ts&"
export * from "./TaxationModality.vue?vue&type=script&lang=ts&"
import style0 from "./TaxationModality.vue?vue&type=style&index=0&id=4de2dde1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2dde1",
  null
  
)

export default component.exports